export default __webpack_public_path__ + "static/media/img_civic_large.ef7482d5.png";